export default "<!-- <div class=\"footer\">\n<div></div>\n</div> -->\n"